// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2j_Bg","noRightPad":"Panel_noRightPad__33oF4","rightPad":"Panel_rightPad__1nidp","highlight":"Panel_highlight__2dfYW","noHighlight":"Panel_noHighlight__1P1T3"};